export const eScreenMode = {
  START: 'eScreenMode:START',
  GAME: 'eScreenMode:GAME',
  PAYTABLE: 'eScreenMode:PAYTABLE'
}